module.exports = __webpack_public_path__ + "img/chevron-right.0f6ac876.svg";